// extracted by mini-css-extract-plugin
export var actionButton = "_ro-0";
export var actionMenuContainer = "_ro-i";
export var bubble = "_ro-2";
export var bubbleActionMenu = "_ro-j";
export var bubbleContext = "_ro-6";
export var bubbleItems = "_ro-7";
export var customer = "_ro-3";
export var divider = "_ro-8";
export var fileList = "_ro-9";
export var hiddenComment = "_ro-o";
export var infoAbove = "_ro-a";
export var internal = "_ro-4";
export var lightActionButton = "_ro-1";
export var link = "_ro-b";
export var merchant = "_ro-5";
export var message = "_ro-c";
export var profilePicture = "_ro-e";
export var quillToolbarContainer = "_ro-f";
export var senderDate = "_ro-g";
export var senderDateCustomer = "_ro-h";
export var senderName = "_ro-d";
export var time = "_ro-k";
export var uploadedImage = "_ro-l";
export var username = "_ro-m";
export var xsmall = "_ro-n";